import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://nehchaleye.com";
const GSC_VERIFICATION = process.env.REACT_APP_GSC_VERIFICATION;

/**
 * Seo — page-level meta tags via react-helmet-async.
 */
export default function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  noindex = false,
}) {
  const canonical = `${SITE_URL}${path}`;
  const fullTitle = title
    ? `${title} | Nehchal Eye Centre`
    : "Nehchal Eye Centre - Expert Eye Care in Noida | Dr. Gurkiran Kaur";
  const desc =
    description ||
    "Fellowship-trained ophthalmologist in Sector 32 Noida. 3000+ cataract surgeries, oculoplasty, glaucoma & pediatric eye care by Dr. Gurkiran Kaur.";
  const ogImage =
    image ||
    "https://customer-assets-v7afamib.emergentagent.net/job_cataract-seo-noida/artifacts/juyfcelq_CLINICLOGO.jpg";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en-IN" href={canonical} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Nehchal Eye Centre" />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {GSC_VERIFICATION ? (
        <meta name="google-site-verification" content={GSC_VERIFICATION} />
      ) : null}
    </Helmet>
  );
}
